<script>
import { Bar, mixins  } from 'vue-chartjs';

export default {
   extends: Bar,
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Object
        }        
    },
    data () {
        return {    
            /*chartData: {
                labels: ['January', 'February'],
                datasets: [
                    {
                    label: 'Data One',
                    backgroundColor: '#f87979',
                    data: [40, 20]
                    }
                ]
            },*/
            options: {
                responsive: true,
                maintainAspectRatio: false   ,
                legend: {
                    onClick: null,
                    labels: {fontColor:'white'}
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            suggestedMin: 0,
                            suggestedMax: 1,
                            fontColor: 'white' 
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            fontColor: 'white' 
                        }
                    }]                    
                }              
            }
        }
    },
   mounted() {
      this.renderChart(this.chartData, this.options)
   }
}

</script>